import * as XLSX from 'xlsx';

// 일부 엑셀 내보내기(예: KICC easyshop 부가세 참조자료)는 워크시트의 !ref 가
// 실제 데이터 범위보다 좁게(설명문 영역만) 잘못 기록되어 있어,
// XLSX.utils.sheet_to_json 이 !ref 를 존중하면 정작 데이터 행을 통째로 누락한다.
// 실제 존재하는 셀 주소에서 범위를 재계산해 전체 행을 AOA 로 읽는다.
export function sheetToAoaFullRange(ws: XLSX.WorkSheet): any[][] {
  let maxR = 0, maxC = 0, has = false;
  for (const key of Object.keys(ws)) {
    if (key[0] === '!') continue;
    const rc = XLSX.utils.decode_cell(key);
    maxR = Math.max(maxR, rc.r);
    maxC = Math.max(maxC, rc.c);
    has = true;
  }
  if (!has) return [];
  const range = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: maxR, c: maxC } });
  return XLSX.utils.sheet_to_json(ws, { header: 1, range, defval: '' });
}
